import {createContext, useContext} from 'react';

import type {FundingSessionContextValue} from 'src/fund/state/types';

export const FundingSessionContext =
  createContext<FundingSessionContextValue | null>(null);

export const useFundingSessionContext = (): FundingSessionContextValue => {
  const context = useContext(FundingSessionContext);

  if (context === null) {
    throw new Error(
      'useFundingSessionContext must be used within FundingSessionContextProvider',
    );
  }

  return context;
};
